import { useEffect, useState } from 'react';

import { initI18n } from '../services/i18n/setup';

export const useAppResources = () => {
  const [isI18nLoaded, setIsI18nLoaded] = useState(false);
  const [i18nError, setI18nError] = useState<unknown>(null);

  useEffect(() => {
    initI18n()
      .then(() => {
        setIsI18nLoaded(true);
      })
      .catch((err: unknown) => {
        setI18nError(err);
      });
  });

  if (i18nError !== null) {
    console.warn(i18nError);
  }

  return isI18nLoaded;
};
